module.exports = __webpack_public_path__ + "img/icon-telemeteri.cdb3e3fa.png";